export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/f587c8ee842f3f4a7593f909731a41704c05f028/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"